<template>
  <component :is="component"
    v-bind="data"
    v-if="component"
    v-on="$listeners">
  </component>
</template>
<script>
export default {
  name: 'VDynamicLoader',
  props: {
    data: {
      type: [Object],
    },
    viewURL: {
      type: [String],
      required: true,
    },
  },
  data() {
    return {
      component: null,
    };
  },
  mounted() {
    this.component = () => ({
      component: import(`@/views/${this.viewURL}`),
    });
  },
};
</script>
